import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53')
];

export const server_loads = [2,8];

export const dictionary = {
		"/(app)": [~9,[2]],
		"/(app)/account": [~10,[2]],
		"/(app)/admin": [~11,[2,3]],
		"/(app)/admin/events/[eventId]": [~12,[2,3]],
		"/(app)/admin/langur": [~13,[2,3]],
		"/(app)/admin/metrics": [14,[2,3]],
		"/(app)/admin/newsletters": [15,[2,3]],
		"/(app)/admin/newsletters/[newsletterIdOrShortKey]": [16,[2,3]],
		"/(app)/admin/organizations": [17,[2,3]],
		"/(app)/admin/organizations/[organizationIdOrScreenName]": [~18,[2,3]],
		"/(app)/admin/search-syntax-tips": [19,[2,3]],
		"/(app)/admin/testim": [20,[2,3]],
		"/(app)/admin/tools": [21,[2,3]],
		"/(app)/admin/users": [22,[2,3]],
		"/(app)/admin/users/me": [~24,[2,3]],
		"/(app)/admin/users/[userIdOrScreenName]": [~23,[2,3]],
		"/(app)/email_domain/[screenName]": [~25,[4]],
		"/(public)/f/[folder]": [~52],
		"/(public)/integrations/canva/callback": [~53],
		"/(app)/integrations/canva/design/download": [~28,[6]],
		"/(app)/integrations/canva/error": [~29,[7]],
		"/(app)/integrations/canva/[userId]/design/create": [~27,[2]],
		"/(app)/integrations/canva/[userId]/design/[id]": [~26,[5]],
		"/(app)/lists/[[listId]]": [~30,[2]],
		"/(app)/newsletters": [~34,[2]],
		"/(app)/newsletters/new": [~36,[2]],
		"/(app)/newsletters/[folderId]": [35,[2]],
		"/(app)/n/[idOrKey]/(show)": [31,[2,8]],
		"/(app)/n/[idOrKey]/edit": [~33,[2]],
		"/(app)/n/[idOrKey]/(show)/preview": [32,[2,8]],
		"/(app)/organization/brandkits": [~39,[2]],
		"/(app)/organization/brandkits/[brandkitId]": [~40,[2]],
		"/(app)/organization/[idOrScreenName]": [~37,[2]],
		"/(app)/organization/[idOrScreenName]/join/[[errorCode]]": [~38,[2]],
		"/(app)/release-notes": [~41,[2]],
		"/(app)/release-notes/[slug]": [~42,[2]],
		"/(app)/templates": [~43,[2]],
		"/(app)/templates/[category]": [~44,[2]],
		"/(app)/templates/[category]/[templatedID]": [~45,[2]],
		"/(noAuthentication)/test/check-exceptions": [49],
		"/(noAuthentication)/test/session/check": [~50],
		"/(noAuthentication)/test/session/read": [~51],
		"/(app)/users/invoice/[invoiceId]": [~47,[2]],
		"/(app)/users/verify_email": [~48,[2]],
		"/(app)/user/[screenName]/[[folder]]": [~46,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';